export interface TableWordNoun {
  sg_nom: string;
  sg_gen: string;
  sg_dat: string;
  sg_acc: string;
  sg_inst: string;
  sg_loc: string;
  sg_voc: string;
  pl_nom: string;
  pl_gen: string;
  pl_dat: string;
  pl_acc: string;
  pl_inst: string;
  pl_loc: string;
}

export interface TableWordVerb {
  v_inf_imperf: string;
  v_inf_perf: string;


  v_imperf_sg_m_pri: string;
  v_imperf_sg_f_pri: string;
  v_imperf_sg_m_sec: string;
  v_imperf_sg_f_sec: string;
  v_imperf_sg_m_ter: string;
  v_imperf_sg_f_ter: string;
  v_imperf_sg_n_ter: string;
  v_imperf_pl_m_pri: string;
  v_imperf_pl_f_n_pri: string;
  v_imperf_pl_m_sec: string;
  v_imperf_pl_f_n_sec: string;
  v_imperf_pl_m_ter: string;
  v_imperf_pl_f_n_ter: string;


  v_perf_sg_m_pri: string;
  v_perf_sg_f_pri: string;
  v_perf_sg_m_sec: string;
  v_perf_sg_f_sec: string;
  v_perf_sg_m_ter: string;
  v_perf_sg_f_ter: string;
  v_perf_sg_n_ter: string;
  v_perf_pl_m_pri: string;
  v_perf_pl_f_n_pri: string;
  v_perf_pl_m_sec: string;
  v_perf_pl_f_n_sec: string;
  v_perf_pl_m_ter: string;
  v_perf_pl_f_n_ter: string;


  v_fin_imperf_sg_pri: string;
  v_fin_imperf_sg_sec: string;
  v_fin_imperf_sg_ter: string;
  v_fin_imperf_pl_pri: string;
  v_fin_imperf_pl_sec: string;
  v_fin_imperf_pl_ter: string;


  v_fin_perf_sg_pri: string;
  v_fin_perf_sg_sec: string;
  v_fin_perf_sg_ter: string;
  v_fin_perf_pl_pri: string;
  v_fin_perf_pl_sec: string;
  v_fin_perf_pl_ter: string;
}
